import { Injectable } from '@angular/core';
import { McticHttpClient } from '@mctic/ng-core';
import { Observable } from 'rxjs';
import { EmpresaAuditora } from '../shared/model/empresa-auditora.model';

@Injectable({
  providedIn: 'root'
})

export class EmpresaAuditoraService {

  private readonly endpoint = '/sepin-backend/rest/empresa-auditora';

  constructor(
    private readonly http: McticHttpClient ) {
  }

  validarRda() {
    return this.http.get(`${this.endpoint}/`);
  }

  obterEmpresaAuditoraPorIdUnico(idUnico: number): Observable<EmpresaAuditora> {
    return this.http.get<EmpresaAuditora>(`${this.endpoint}/id-unico/${idUnico}`);
  }



}
